<template>
  <ul :class=" 'vuejs-countdown ' + colorLevel ">
    <li v-if="days > 0">
      <p class="digit">{{ days | twoDigits }}</p>
      <p class="text">{{ days > 1 ? 'dd' : 'dd' }}</p>
    </li>
    <li>
      <p class="digit">{{ hours | twoDigits }}</p>
      <p class="text">{{ hours > 1 ? $t('horas') : $t('hora') }}</p>
    </li>
    <li>
      <p class="digit">{{ minutes | twoDigits }}</p>
      <p class="text">min</p>
    </li>
    <li>
      <p class="digit">{{ seconds | twoDigits }}</p>
      <p class="text">{{ $t('seg') }}</p>
    </li>
  </ul>
</template>

<i18n>
{
  "es": {
    "horas": "horas",
    "hora": "hora",
    "seg": "seg"
  },
  "en": {
    "horas": "hours",
    "hora": "hour",
    "seg": "sec"
   }
}
</i18n>

<script>
let interval = null;

export default {
  name: 'vuejsCountDown',
  props: {
    deadline: {
      type: String
    },
    end: {
      type: String
    },
    stop: {
      type: Boolean
    }
  },
  data() {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      date: null,
      diff: 0,
    }
  },
  created() {
    if (!this.deadline && !this.end) {
      throw new Error("Missing props 'deadline' or 'end'");
    }
    let endTime = this.deadline ? this.deadline : this.end;
    this.date = Math.trunc(Date.parse(endTime.replace(/-/g, "/")) / 1000);
    if (!this.date) {
      throw new Error("Invalid props value, correct the 'deadline' or 'end'");
    }
    interval = setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000);
    }, 1000);
  },
  computed: {
    seconds() {
      return Math.trunc(this.diff) % 60
    },
    minutes() {
      return Math.trunc(this.diff / 60) % 60
    },
    hours() {
      return Math.trunc(this.diff / 60 / 60) % 24
    },
    days() {
      return Math.trunc(this.diff / 60 / 60 / 24)
    },
    colorLevel(){
      if( this.hours > 0 || this.minutes > 30 ){
        return 'level-green'
      }
      if( this.hours == 0 && this.minutes < 30 && this.minutes >= 10 ){
        return 'level-orange'
      }
      if( this.hours == 0 && this.minutes < 10 ){
        return 'level-red'
      }
    }
  },
  watch: {
    now(value) {
      this.diff = this.date - this.now;
      if(this.diff <= 0 || this.stop){
        this.diff = 0;
        // Remove interval
        clearInterval(interval);
      }
    }
  },
  filters: {
    twoDigits(value) {
      if ( value.toString().length <= 1 ) {
        return '0'+value.toString()
      }
      return value.toString()
    }
  },
  destroyed() {
    clearInterval(interval);
  }
}
</script>
<style>
.vuejs-countdown {
  padding: 0;
  margin: 0;
}
.vuejs-countdown li {
  display: inline-block;
  margin: 0 3px;
  text-align: center;
  position: relative;
}
.vuejs-countdown li p {
    margin: 0;
}
.vuejs-countdown li:after {
  font-family: 'Roboto Mono', monospace;
  content: ":";
  position: absolute;
  top: -6px;
  right: -8px;
  font-size: 15px;
}
.vuejs-countdown li:first-of-type {
  margin-left: 0;
}
.vuejs-countdown li:last-of-type {
  margin-right: 0;
}
.vuejs-countdown li:last-of-type:after {
  content: "";
}
.vuejs-countdown .digit {
  font-family: 'Roboto Mono', monospace;
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 0;
}
.vuejs-countdown .text {
  text-transform: uppercase;
  margin-bottom: 0;
  font-size: 8px;
  line-height: 18px
}
.level-green{ color: #4CAF50; } 
.level-orange{ color: #FF9800; }
.level-red{ color: #F44336; } 
</style>